import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface CreateLocalProgramIncrementDialogData {
  name: string;
  goal: string;
  start: Date;
  numberOfSprints: number;
  sprintDuration: number;
  program: number;
  sprintPrefix: string;
  minDate: string;
}

@Component({
  selector: 'app-create-task-dialog',
  templateUrl: './create-program-increment-dialog.component.html',
  styleUrls: ['./create-program-increment-dialog.component.scss']
  })
export class CreateProgramIncrementDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<CreateProgramIncrementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateLocalProgramIncrementDialogData) { }

  ngOnInit() {
  }

  cancel() {
    this.dialogRef.close();
  }
}
